/** 设备域接口（与 apps/server/src/routes/devices.ts 一一对应） */
import type { Device, DeviceSource, DeviceSpec, DeviceType, TelemetryPoint } from '@znjj/shared';
import { apiGet, apiJson } from './client';

/** 添加设备向导的房间选项（与原型 mock.js 一致，燃气报警器默认厨房） */
export const ROOMS = ['客厅', '厨房', '工作室', '卧室', '院子', '全屋'];

export interface DeviceList {
  list: Device[];
  online: number;
  total: number;
}

export const devicesApi = {
  list: (): Promise<DeviceList> => apiGet<DeviceList>('/api/devices'),

  types: (): Promise<{ list: DeviceSpec[] }> => apiGet<{ list: DeviceSpec[] }>('/api/devices/types'),

  create: (input: {
    name: string;
    type: DeviceType;
    room?: string | null;
    source?: DeviceSource;
  }): Promise<{ device: Device }> => apiJson<{ device: Device }>('POST', '/api/devices', input),

  update: (id: string, patch: { name?: string; room?: string | null }): Promise<{ device: Device }> =>
    apiJson<{ device: Device }>('PATCH', `/api/devices/${id}`, patch),

  remove: (id: string): Promise<{ deleted: boolean }> =>
    apiJson<{ deleted: boolean }>('DELETE', `/api/devices/${id}`),

  claim: (id: string): Promise<{ device: Device }> =>
    apiJson<{ device: Device }>('POST', `/api/devices/${id}/claim`),

  unclaim: (id: string): Promise<{ device: Device }> =>
    apiJson<{ device: Device }>('DELETE', `/api/devices/${id}/claim`),

  /** 绑定码认领：设备自注册后把 6 位码显示在屏幕/串口，用户输入即收进当前账号 */
  pair: (code: string): Promise<{ device: Device }> =>
    apiJson<{ device: Device }>('POST', '/api/devices/pair', { code }),

  /** 指令下发：202 Accepted，真实状态以 SSE 上报为准 */
  command: (id: string, code: string, value: unknown): Promise<{ accepted: boolean }> =>
    apiJson<{ accepted: boolean }>('POST', `/api/devices/${id}/commands`, { code, value }),

  telemetry: (
    id: string,
    key: string,
    hours = 24,
  ): Promise<{ key: string; hours: number; points: TelemetryPoint[] }> =>
    apiGet<{ key: string; hours: number; points: TelemetryPoint[] }>(
      `/api/devices/${id}/telemetry?key=${encodeURIComponent(key)}&hours=${hours}`,
    ),
};

/** 设备墙查询键 */
export const deviceKeys = {
  list: ['devices'] as const,
  types: ['device-types'] as const,
  telemetry: (id: string, key: string, hours: number) => ['telemetry', id, key, hours] as const,
};
